import ItemConfig from "./ItemConfig";
import QuestionPlayer from "../question/QuestionPlayer";
import SequencePlayer from "../sequence/SequencePlayer";
import QuestionPaths from "../../players/question/QuestionPaths";
import QuestionConfig from "../question/QuestionConfig";
import SequenceConfig from "../sequence/SequenceConfig";
import BaseContent from "../utils/BaseContent";
import { Subject, Observable } from "rxjs";
import { GlobalResourceManager } from "../../helpers/GlobalResourceManager";

interface ISequenceProps {
  type: string;
  itemList: any[];
  algoConfig: any;
}

export default abstract class BaseItem extends BaseContent {
  protected questionPlayer: QuestionPlayer | undefined;
  protected sequencePlayer: SequencePlayer;
  // protected loadedMechanics: Array<string> = [];
  protected itemEventSubject: Subject<any> = new Subject<any>();
  constructor(public config: ItemConfig) {
    super();
  }
  public get observable(): Observable<any> {
    return this.itemEventSubject.asObservable();
  }
  public async loadQuestionPlayer(
    questionConfig: QuestionConfig
  ): Promise<void> {
    if (this.config.appConfig) {
      questionConfig.set({ appConfig: this.config.appConfig });
    }
    // if (this.questionPlayer === undefined) {
    this.questionPlayer = new QuestionPlayer(questionConfig);
    // }
    // if (
    //   (this.loadedMechanics as any).includes(questionConfig.contentTypeID) ===
    //   false
    // ) {
    await this.questionPlayer.loadLibWithResources();
    //   this.loadedMechanics.push(questionConfig.contentTypeID);
    // }
  }
  public async loadSequencePlayer(
    sequenceConfig: SequenceConfig
  ): Promise<void> {
    await GlobalResourceManager.loadResource(
      sequenceConfig,
      sequenceConfig.contentTypeID,
      sequenceConfig.paths
    );
  }
  public async initSequencePlayer(
    sequenceConfig: SequenceConfig
  ): Promise<void> {
    this.sequencePlayer = new SequencePlayer(sequenceConfig);
    await this.sequencePlayer.loadLibWithResources();
  }

  public async loadQuestionLibsWithConfigWithoutRes(config): Promise<void> {
    if (this.config.itemProps && this.config.itemProps.questions) {
      for (let question of this.config.itemProps.questions) {
        if (question) {
          let paths = new QuestionPaths(question.type);
          await GlobalResourceManager.loadResource(
            config,
            question.type,
            paths
          );
          // let contentLib: any = getLibFromPath(paths.lib.slice());
          // if (contentLib === undefined) {
          //   await getContentLibrary(paths.lib.slice());
          //   contentLib = getLibFromPath(paths.lib.slice());
          // }
          // if ((this.loadedMechanics as any).includes(question.type) === false) {
          //   let content = new contentLib(config);
          //   await content.loadResources(paths);
          //   this.loadedMechanics.push(question.type);
          //   // content = null;
          // }
        }
      }
    }
  }

  public async startQuestion(): Promise<any> {
    return await this.questionPlayer!.start();
  }
  public getMechanicName(questionType): string {
    return questionType.split(".")[4];
  }
  public getQuestionTypeName(questionType): string {
    return questionType.split(".")[3];
  }
  public getContentType(type): string {
    return type.split(".")[2];
  }
  public getTotalQuestions(): number {
    let totalQuestions = 0;
    if (this.config.itemProps) {
      for (let question of this.config.itemProps.questions) {
        if (!this.isScorecard(question) && !this.isTutorial(question)) {
          totalQuestions++;
        }
      }
    }
    return totalQuestions;
  }
  public getQuestionID(questionProps): string {
    let id = questionProps.questionID || "Prismic_ID = " + questionProps.uid;
    return id;
  }
  protected isScorecard(question: any): boolean {
    return (
      question.attributes !== undefined &&
      question.attributes.scorecard !== undefined &&
      JSON.parse(question.attributes.scorecard) === true
    );
  }
  protected isTutorial(question: any): boolean {
    return (
      question.attributes !== undefined &&
      question.attributes.tutorial !== undefined &&
      JSON.parse(question.attributes.tutorial) === true
    );
  }
  public getAllQuestions(): any[] {
    let questions: any[] = [];
    if (this.config.itemProps) {
      for (let question of this.config.itemProps.questions) {
        if (!this.isScorecard(question) && !this.isTutorial(question)) {
          questions.push(question);
        }
      }
    }
    return questions;
  }
  public getAllQuestionsWithTutorial(): any[] {
    let questions: any[] = [];
    if (this.config.itemProps) {
      for (let question of this.config.itemProps.questions) {
        if (!this.isScorecard(question)) {
          questions.push(question);
        }
      }
    }
    return questions;
  }

  public getAllQuestionsWithTutorialAndScorecard(): any[] {
    let questions: any[] = [];
    if (this.config.itemProps) {
      for (let question of this.config.itemProps.questions) {
        questions.push(question);
      }
    }
    return questions;
  }
  public getFirstScorecard(): any {
    if (this.config.itemProps) {
      for (let question of this.config.itemProps.questions) {
        if (this.isScorecard(question)) {
          return question;
        }
      }
    }
    return null;
  }
  public getFirstTutorial(): any {
    if (this.config.itemProps) {
      for (let question of this.config.itemProps.questions) {
        if (this.isTutorial(question)) {
          return question;
        }
      }
    }
    return null;
  }
  public getAllScorecards(): any {
    let scorecards: any[] = [];
    if (this.config.itemProps) {
      for (let question of this.config.itemProps.questions) {
        if (this.isScorecard(question)) {
          scorecards.push(question);
        }
      }
    }
    return scorecards;
  }
  public getAllTutorials(): any {
    let tutorials: any[] = [];
    if (this.config.itemProps) {
      for (let question of this.config.itemProps.questions) {
        if (this.isTutorial(question)) {
          tutorials.push(question);
        }
      }
    }
    return tutorials;
  }
}
